import { toggleMenu } from "../../../_src/components/dropdown"
import { purify } from "../../../_src/components/purify";

export function searchBulletinsMarketDownloads(period) {
    var btnLoadMore = document.querySelector(`[data-action=load-more-${period}]`)

    function search() {
        btnLoadMore.classList.add("loading")
        var form = document.querySelector('#filter-bulletinsMarket');
        var data = new FormData(form);

        fetch(`/ifag/dados-e-analises/ajax/bulletins-market-downloads/p${btnLoadMore.getAttribute("data-page")}?&accordionTitle=${period}`,  {
            method: "POST",
            body: data
        })
        .then((response) => {
            return response.text();

        }).then((response) => {
            document.querySelector(`#result-bulletinsMarket-downloads-${period}`).insertAdjacentHTML('beforeend', response);
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            btnLoadMore.classList.remove("loading")

            if (parseInt(btnLoadMore.dataset.page) == parseInt(btnLoadMore.dataset.total)) {
                btnLoadMore.classList.add('hidden');
            }
        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { setTimeout(() => { search(false) }, 100), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
    }
}

function checkIfAccordionExist() {
    if (document.querySelector("#result-bulletinsMarket-downloads-diario")) {
        searchBulletinsMarketDownloads("diario");
    }

    if (document.querySelector("#result-bulletinsMarket-downloads-semanal")) {
        searchBulletinsMarketDownloads("semanal");
    }

    if (document.querySelector("#result-bulletinsMarket-downloads-mensal")) {
        searchBulletinsMarketDownloads("mensal");
    }
}

export function searchBulletinsMarketAccordion() {
    function search() {
        var form = document.querySelector('#filter-bulletinsMarket');
        var data = new FormData(form);

        document.querySelector("#result-bulletinsMarket-container").innerHTML = "";
        document.querySelector(".loader-bulletins-market").classList.remove("hidden")

        document.querySelectorAll("#filter-bulletinsMarket fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        fetch(`/ifag/dados-e-analises/ajax/bulletins-market-accordion/`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            document.querySelector("#result-bulletinsMarket-container").innerHTML = purify(response);
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            document.querySelector(".loader-bulletins-market").classList.add("hidden")

            toggleMenu();
            checkIfAccordionExist();

            document.querySelectorAll("#filter-bulletinsMarket fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })
        });
    }

    document.querySelector("#filter-bulletinsMarket").addEventListener("change", function() {  setTimeout(() => { search(false) }, 100)}, false);
}

if (document.querySelector("#filter-bulletinsMarket") && document.querySelector("#result-bulletinsMarket-container")) {
    searchBulletinsMarketAccordion();
    checkIfAccordionExist();
}
